export default [
	{
		path: '/events',
		name: 'events',
		component: () => import('@/views/Event/Events.vue'),
		meta: { requiresAuth: true, permission: 'view_events' }
	},
	{
		path: '/events/create',
		name: 'events.create',
		component: () => import('@/views/Event/CreateEvent.vue'),
		meta: { requiresAuth: true, permission: 'create_event' }
	},
	{
		path: '/events/:id',
		props: true,
		component: () => import('@/views/Event/Event.vue'),
		meta: { requiresAuth: true, permission: 'view_event' }
	}
]
